module.exports = __webpack_public_path__ + "static/media/empty.4a2c0e12.png";